
import itMessages from '../locales/it-IT';

const ItLang = {
    messages: {
        ...itMessages
    },
    locale: 'it-IT',
    
};

export default ItLang;